// Thank this chinese guy: https://github.com/lian-fei/vue-postmessage#readme

export default {
  install: function(Vue) {
    Vue.prototype.$postMessage = function(message, targetOrigin, target) {
      if (targetOrigin && target) {
        target.postMessage(message, targetOrigin);
      }
    };

    Vue.prototype.$receiveMessage = function(callback, options) {
      if (options && options.remove) {
        window.removeEventListener("message", callback);
      } else {
        if (window.addEventListener) {
          window.addEventListener("message", callback, false);
        }
      }
    };
  }
};
